// extracted by mini-css-extract-plugin
export var productImage = "_ou-1";
export var viewLink = "_ou-2";
export var wishlistItem = "_ou-0";